export default {"src":"/_next/static/media/privacy.0b358ccb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};